import {
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import cls from 'classnames'

import { useStyles } from './styles'

export type UnitType = 'hectares' | 'percentage'

interface UnitToggleProps {
  selectedUnit: UnitType
  onUnitChange: (unit: UnitType) => void
}

export const UnitToggle = ({ selectedUnit, onUnitChange }: UnitToggleProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography className={classes.label}>Unidade de medida:</Typography>

      <div className={classes.buttonContainer}>
        <RadioGroup
          value={selectedUnit}
          onChange={(e) => onUnitChange(e.target.value as UnitType)}
          className={classes.radioGroup}
        >
          <FormControlLabel
            value='hectares'
            control={
              <Radio
                className={classes.radio}
                icon={<span />}
                checkedIcon={<span />}
              />
            }
            label='Hectares (ha)'
            className={cls(classes.radioLabel, {
              [classes.buttonActive]: selectedUnit === 'hectares',
            })}
          />

          <Divider orientation='vertical' className={classes.divider} />

          <FormControlLabel
            value='percentage'
            control={
              <Radio
                className={classes.radio}
                icon={<span />}
                checkedIcon={<span />}
              />
            }
            label='Porcentagem (%)'
            className={cls(classes.radioLabel, {
              [classes.buttonActive]: selectedUnit === 'percentage',
            })}
          />
        </RadioGroup>
      </div>
    </div>
  )
}
